import { Navigate, useLocation } from "react-router-dom";
import WidgetsDemoSelector from "./WidgetsDemoSelector";
import WidgetsDemoView from "./WidgetsDemoView";
import { readActiveViews, WIDGET_VIEWS } from "./widgetsDemoStorage";
import "./widgetsDemoOverrides.css";

const WidgetsDemo = () => {
  const location = useLocation();
  const savedViews = readActiveViews();
  const activeViews = savedViews && savedViews.length ? savedViews : ["all"];
  const pathname = location.pathname;
  const search = location.search || "";
  const normalizedPathname =
    pathname !== "/" && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;

  const isPreferencesRoute =
    normalizedPathname === "/widgets-demo/preferences";
  const isMainRoute = normalizedPathname === "/widgets-demo";

  if (isMainRoute) {
    // Default landing page for the widgets demo is "All Widgets"
    return (
      <Navigate to={`/widgets-demo/${activeViews[0]}${search}`} replace />
    );
  }

  if (isPreferencesRoute) {
    // If no saved preferences exist, selector defaults to the first view (All Widgets).
    return (
      <WidgetsDemoSelector
        initialActiveViews={savedViews || WIDGET_VIEWS}
      />
    );
  }

  return <WidgetsDemoView activeViews={activeViews} />;
};

export default WidgetsDemo;
